
// @ts-nocheck

import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Components/Button/Button";
import FirstSectionModal from "../../Components/CommonMultiSelectComponent/FirstSelectionModal";
import useKeyDown from "../../Components/FormComponents/AddLoad/text";
import { Vehicle_Managent_Inputs } from "../../Components/FormComponents/AddVehicleManagent/AddVehicleManagent.config";
import { FormInputSectionComponent } from "../../Components/FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast, WarningToast } from "../../Components/ToastComponent/RectHotToast";
import useConcatenatedString from "../../custom_hooks/useConcatenatedString";
import RCDetailsModal from "./RcDetailsModal/RCDetailsModal";

export const GET_VEHICLE_LENGTH = gql`
  query SearchVehicleLengthMasters($keyword: String) {
    searchVehicleLengthMasters(keyword: $keyword) {
      _id
      length
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

const Get_Vehicle_Category = gql`
  query searchVehicleTypeMasters($keyword: String, $Limit: Int) {
    searchVehicleTypeMasters(keyword: $keyword, Limit: $Limit) {
      _id
      Vehicle_Type
    }
  }
`;
const Get_Vehicle_Category_By_Id = gql`
  query searchVehicleCategory_With_VechileMasters($keyword: String!, $Common_Id: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $Common_Id) {
      _id
      Name
    }
  }
`;

const CREATE_VEHICLE_MANAGEMENT = gql`
  mutation CreateVehicleManagement($createInput: VehicleManagementInput!, $userId: ID) {
    createVehicleManagement(createInput: $createInput, UserId: $userId) {
      _id
      Unique_Id
      UserId
      Vehicle_No
      Vehicle_Type
      Vehicle_Category
      Vehicle_Length
      Payload_Capacity
      createdAt
      updatedAt
      RC_Data {
        _id
        Unique_Id
        Blacklist_Status
        Body_Type_Description
        ChassIs_No
        Father_Name
        Finance_Company
        insurance {
          company
          expiry_date
          Insurance_Policy_No
        }
        Permit_Due_Date
        National_Permit_Issued_By
        Permit_Doc_No
        Norms_Description
        Owner_Permanent_Address
        Engine_No
        Expiry_Date
        Fitness_Due_Date
        NOC_Details
        PUCC_Due_Date
        PUCC_Doc_No
        Registration_Date
        Registration_Location
        Registration_Number
        State_Code
        Status_As_On
        Road_Tax_Due_Date
        Vehicle_Owner
        Vehicle_Category
        Vehicle_Class_Description
        Vehicle_Color
        Load_Capacity
        Vehicle_Fuel_Description
        Vehicle_Make_Model
        Vehicle_Maker_Description
        Vehicle_Manufactured_Date
        Vehicle_Number_Of_Cylinders
        Vehicle_Seating_Capacity
        Vehicle_Sleeper_Capacity
        Vehicle_Stand_Capacity
        Vehicle_Unladen_Weight
        Vehicle_Wheelbase
        Vehicle_Type
        Commercial_Status
        RTO_Code
        Vehicle_Financed
        Insurance_Due_Date
        Insurance_Expired
        Vehicle_Fitness_Expired
        Vehicle_Age
        City
        State
      }
    }
  }
`;
const Get_Vehicle_By_Id = gql`
  query VehicleManagement($id: ID!) {
    VehicleManagement(id: $id) {
      _id
      Unique_Id
      UserId
      Vehicle_No
      Vehicle_Type
      Vehicle_Category
      Vehicle_Length
      Payload_Capacity
    }
  }
`;

const AddVehicleAtBid = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Vehicle Managent");
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  // eslint-disable-next-line
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store: any) => store.FormFieldData);
  const [fielddata] = fielddataRedux.selectedRow;
  const [rcData, setRCData] = useState({});
  const [rcDetailsModal, setRcDetailsModal] = useState(false);
  const [selectedBranches, setSelectedBranch] = useState({});
  const [GetDataByID] = useLazyQuery(Get_Vehicle_By_Id, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [allFieldsData, setAllFieldsData] = useState({});
  const { data: getCompanyData } = useQuery(Get_Vehicle_Category);

  const [showModal, setShowModal] = useState(false);
  const [CreateVechicle, { loading: CreateVechicleload }] = useMutation(CREATE_VEHICLE_MANAGEMENT, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const { data: vehicleLengths } = useQuery(GET_VEHICLE_LENGTH, {
    variables: {
      keyword: "",
    },
  });

  const FormData = useSelector((store: any) => store.FormFieldData);
  const dispatch = useDispatch();
  const SelectedBranches = useSelector((store: any) => store.FormFieldData.MultiSelectedRows);
  const VehicleLoadingState = CreateVechicleload ? true : false;
  useEffect(() => {
    if (modifiedTypeOfPortal !== "Add Vehicle Managent") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        setAllFieldsData(data?.VehicleManagement);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  useEffect(() => {
    setalldata(FormData.fielddata);
    // setFormType(FormData.typeOfForm);
    setSelectedRows(FormData.selectedRows);
  }, [FormData]);

  useEffect(() => {
    if (FormData?.masterData?.UserId) {
      dispatch({
        type: "SearchMasterData",
        payload: {
          UserId: {
            _id: FormData?.masterData?.UserId?._id,
            FullName: FormData?.masterData?.UserId?.FullName,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   setAllFieldsData(fielddata);
  // }, [fielddata]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const handleAdd_vehicle_number = () => {
    setShowModal(true);
  };
  function getLastElementOfLastKey(obj) {
    // Check if the object is undefined or has no keys
    if (!obj || Object.keys(obj).length === 0) {
      return undefined;
    }

    // Get all keys of the object
    const keys = Object.keys(obj);

    // Check if the last key is undefined
    const lastKey = keys[keys.length - 1];
    if (!lastKey) {
      return undefined;
    }

    // Get the array corresponding to the last key
    const lastArray = obj[lastKey];
    // Check if the array is undefined or empty
    if (!lastArray || lastArray.length === 0) {
      return undefined;
    }

    // Get the last element of this array
    const lastElement = lastArray[lastArray.length - 1];

    // Return the last element, or undefined if it doesn't exist
    return lastElement;
  }
  //function to perform CRUD Opetation

  const submit = async () => {
    let data: any = {};
    for (let key in alldata) {
      data = {
        ...data,
        ...alldata[key],
      };
    }
    data.Company_ID = FormData?.masterData?.Company_ID?._id;

    // here default type is add if the type of portal is not defined or we can considar it add functionality
    const value = getLastElementOfLastKey(FormData?.MultiSelectedRows);
    const vehicleLength = vehicleLengths.searchVehicleLengthMasters.find(
      (item) => item.Search_Value === FormData.fielddata.Vehicle_Managent?.Vehicle_Length
    );

    const Final_post_data = {
      Vehicle_No: FormData.fielddata.Vehicle_Managent?.Vehicle_No,
      Vehicle_Length: vehicleLength?._id,
      Vehicle_Category: value?._id,
      Payload_Capacity: FormData.fielddata.Vehicle_Managent?.Payload_Capacity,
    };

    for (const [key, value] of Object.entries(Final_post_data)) {
      if (value === undefined || value === null || value === "") {
        WarningToast(`${key} is not defined or needs to be filled`);
        return; // Stop execution if a field is invalid
      }
    }

    await CreateVechicle({
      variables: {
        createInput: Final_post_data,
        userId: FormData?.masterData?.UserId._id,
      },
    })
      .then((res) => {
        SuccessToast("Vehicle Created Successfully");
        setRCData(res.data.createVehicleManagement.RC_Data);
        setRcDetailsModal(true);
        // Closeformfunction();
      })
      .catch((err) => {
        // settoggle(toggle);
        ErrorToast(err?.message);
      });

    // if (error_v) {
    //   ErrorToast(error_v?.message);
    // }
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({
      type: "ClearData",
      payload: { fielddata: { Vehicle_Managent: {} }, MultiSelectedRows: {} },
    });
  };

  const SaveAndClose = () => {
    submit();
    // Closeformfunction();
  };

  const HandleKeyDownf3 = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.ctrlKey && event.shiftKey && event.key === "S") {
        submit();
      } else if (event.keyCode === 27) {
        settoggle(false);
        dispatch({ type: "ClearData", payload: { data: {} } });
        return Closeformfunction();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Closeformfunction]
  );
  useKeyDown(HandleKeyDownf3);

  function determineButtonLabel(selectedBranches) {
    for (const key in selectedBranches) {
      if (selectedBranches[key].length >= 1) {
        return "Selected";
      }
    }
    return "Select";
  }

  const buttonLabel = determineButtonLabel(SelectedBranches);

  if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Vehicle Managent") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={VehicleLoadingState}
        />
      </Reactportal>
    );
  }
  return (
    <>
      <div>
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        >
          <>
            {showModal && (
              <FirstSectionModal
                show={showModal}
                query={Get_Vehicle_Category_By_Id}
                data={getCompanyData && getCompanyData.searchVehicleTypeMasters}
                TypeOfPortal={"Select Vehicle"}
                setModal={() => setShowModal(false)}
                fielddata={selectedBranches}
                selectedBranches={selectedBranches}
                getSelectedBranches={(data: any) => setSelectedBranch(data)}
              />
            )}
            <div className="formContainer">
              {Vehicle_Managent_Inputs.map((e, i) => {
                return (
                  <div className="FormSectionParent">
                    <div className="FormSection" style={{ width: "400px", maxWidth: "280px" }}>
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        // TypeOfPortal={TypeOfPortal}
                        // configData={data}
                        accountId={""}
                      />
                      <div className="vehicle_category">
                        <p>Vehicle Category</p>
                        {/* <button onClick={handleAdd_vehicle_number} className={"All"}>
                            Select
                          </button> */}
                        <Button
                          children=""
                          disabled=""
                          action={handleAdd_vehicle_number}
                          text={buttonLabel}
                          name={"All"}
                          type={""}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}

              {rcDetailsModal && (
                <Reactportal
                  open={rcDetailsModal}
                  onClose={() => setRcDetailsModal(false)}
                  TypeOfPortal={modifiedTypeOfPortal}
                >
                  <RCDetailsModal
                    RC_Data={rcData}
                    onClose={() => {
                      setRcDetailsModal(false);
                      // onClose();
                    }}
                  />
                  {/* <div></div> */}
                </Reactportal>
              )}
            </div>
            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitform={submit}
              submitType={submitType}
              SaveAndClose={SaveAndClose}
              handleformclose={() => {
                Closeformfunction();
                settoggle(!toggle);
              }}
              loadingState={VehicleLoadingState}
            />
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddVehicleAtBid;
